import type { ReactNode } from "react";

import { Navigate } from "react-router";

import { useMe } from "@/context/user-context";
import { routes } from "@/routes";

export function SelectCompByRole({
  playerComp,
  clubComp,
  adminComp,
}: {
  playerComp: ReactNode;
  clubComp: ReactNode;
  // Un admin porte role="player" : sur les écrans réservés aux clubs (liste des
  // joueurs, fiche joueur) il tomberait sur le playerComp, c'est-à-dire une 404.
  // Les routes concernées passent donc explicitement la vue à lui servir.
  adminComp?: ReactNode;
}) {
  const { user } = useMe();

  if (user.isAdmin && adminComp) {
    return adminComp;
  }

  if (user.role === "player") {
    return playerComp;
  }

  if (user.role === "club") {
    return clubComp;
  }

  return <Navigate to={routes.signup} />;
}
